import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

export const itemKeys = {
  all: ["items"] as const,
  list: (filters: { search?: string; status?: string }) => ["items", "list", filters] as const,
  detail: (id: string) => ["items", "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const timeEntryKeys = {
  all: ["time-entries"] as const,
  lists: () => ["time-entries", "list"] as const,
  list: (params?: Record<string, unknown>) => ["time-entries", "list", params] as const,
  weeklySummary: (week: string) => ["time-entries", "weekly-summary", week] as const,
  historySummary: (filters: Record<string, unknown>) =>
    ["time-entries", "history-summary", filters] as const,
} as const;

export const woKeys = {
  all: ["work-orders"] as const,
  lists: () => ["work-orders", "list"] as const,
  list: (params?: Record<string, unknown>) => ["work-orders", "list", params] as const,
  detail: (id: string) => ["work-orders", "detail", id] as const,
} as const;

export const jobTypeKeys = {
  all: ["job-types"] as const,
  list: () => ["job-types", "list"] as const,
} as const;

export const categoryKeys = {
  all: ["categories"] as const,
  list: (params?: Record<string, unknown>) => ["categories", "list", params] as const,
  detail: (id: string) => ["categories", "detail", id] as const,
  coverage: () => ["categories", "coverage"] as const,
} as const;

export const auditLogKeys = {
  all: ["audit-log"] as const,
  list: (params?: Record<string, unknown>) => ["audit-log", "list", params] as const,
} as const;

export const configKeys = {
  all: ["config"] as const,
} as const;

export const overheadCategoryKeys = {
  all: ["overhead-categories"] as const,
  list: (params?: Record<string, unknown>) => ["overhead-categories", "list", params] as const,
  detail: (id: string) => ["overhead-categories", "detail", id] as const,
  active: () => ["overhead-categories", "active"] as const,
} as const;
